import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD,
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID,

    ACTION_TRIALGROUPITEMTEMPLATE_SAVE,

    ACTION_TRIALGROUPITEMTEMPLATE_CREATE,

    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE,

    ITrialGroupItemTemplateLoadAction,
    ITrialGroupItemTemplateLoadByIdAction,
    ITrialGroupItemTemplateLoadFailureAction,
    ITrialGroupItemTemplateLoadSuccessAction,

    ITrialGroupItemTemplateSaveAction,
    ITrialGroupItemTemplateSaveSuccessAction,
    ITrialGroupItemTemplateSaveFailureAction,

    ITrialGroupItemTemplateCreateAction,
    ITrialGroupItemTemplateCreateSuccessAction,
    ITrialGroupItemTemplateCreateFailureAction,

    ITrialGroupItemTemplateValidateAction,
    ITrialGroupItemTemplateValidateSuccessAction,
    ITrialGroupItemTemplateValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupItemTemplate";
import { trialGroupItemTemplatesApi } from "../services/trialGroupItemTemplates";


export const
    getTrialGroupItemTemplatesEpic = (action$): Observable<ITrialGroupItemTemplateLoadSuccessAction | ITrialGroupItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATE_LOAD)
            .mergeMap((action: ITrialGroupItemTemplateLoadAction) => {
                return trialGroupItemTemplatesApi
                    .getTrialGroupItemTemplates(action.groupId)
                    .map(response =>
                        LoadSuccess(response.trialGroupItemTemplates, response.trialGroupItemsByTrialGroupItemTemplateCategory, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupItemTemplatesByIdEpic = (action$): Observable<ITrialGroupItemTemplateLoadSuccessAction | ITrialGroupItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupItemTemplateLoadByIdAction) => {
                return trialGroupItemTemplatesApi
                    .getTrialGroupItemTemplateById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupItemTemplate, undefined, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupItemTemplateEpic = (action$): Observable<ITrialGroupItemTemplateSaveSuccessAction | ITrialGroupItemTemplateSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATE_SAVE)
            .mergeMap((action: ITrialGroupItemTemplateSaveAction) => {
                return trialGroupItemTemplatesApi
                    .setTrialGroupItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupItemTemplateEpic = (action$): Observable<ITrialGroupItemTemplateCreateSuccessAction | ITrialGroupItemTemplateCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATE_CREATE)
            .mergeMap((action: ITrialGroupItemTemplateCreateAction) => {
                return trialGroupItemTemplatesApi
                    .createTrialGroupItemTemplate(action.groupId)
                    .map(response =>
                        CreateSuccess(response.trialGroupItemTemplate, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupItemTemplateEpic = (action$): Observable<ITrialGroupItemTemplateValidateSuccessAction | ITrialGroupItemTemplateValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE)
            .mergeMap((action: ITrialGroupItemTemplateValidateAction) => {
                return trialGroupItemTemplatesApi
                    .validateTrialGroupItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }